<template>
  <div class="text-center custom-progress-bar">
    <v-overlay v-model="progressbarData.progressbarStatus">
      <div class="loader">
        <span class="box"></span>
        <span class="box"></span>
        <span class="box"></span>
        <span class="box"></span>
        <span class="box"></span>
        <span class="box"></span>
        <div class="code">
          <img src="@/assets/images/progress-bar-logo.png" width="180px" style="opacity:0.75" />
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["progressbarData"]),
  },
};
</script>
<style scoped>
.progressImage {
  opacity: 0.5;
}
.custom-progress-bar {
  z-index: 9999;
}
</style>

<style>
.loader {
  width: 180px;
  height: 170px;
  position: relative;
}
.loader::before,
.loader::after {
  content: "";
  width: 0;
  height: 0;
  position: absolute;
  bottom: 30px;
  left: 15px;
  z-index: 1;
  transform: scale(0);
  transition: all 0.2s ease;
}
.loader .code {
  position: absolute;
  z-index: 99;
  bottom: -3px;
  -webkit-animation-name: spaceboots;
  -webkit-transform-origin: 50% 50%;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
}
.loader .box {
  width: 100%;
  height: 140px;
  display: block;
  color: white;
  position: absolute;
  top: -22px;
  left: 31px;
  z-index: 2;
  overflow: hidden;
}
.loader .box::before,
.loader .box::after {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.loader .box:nth-child(2)::before {
  content: "\f19d";
  -webkit-text-stroke: 1.5px white;
  color: transparent;
  font-size: 18px;
  animation: a 0.7s linear infinite;
}
.loader .box:nth-child(3)::before {
  font-size: 20px;
  content: "\41";
  animation: b 1s linear infinite;
}
.loader .box:nth-child(3)::after {
  content: "\f518";
  -webkit-text-stroke: 1px white;
  color: transparent;
  animation: c 0.75s linear infinite;
}
.loader .box:nth-child(4)::before {
  content: "\42";
  font-size: 18px;
  animation: d 1.1s linear infinite;
}
.loader .box:nth-child(5)::before {
  font-size: 20px;
  content: "\f305";
  -webkit-text-stroke: 1px white;
  color: transparent;
  animation: e 0.8s linear infinite;
}
.loader .box:nth-child(5)::after {
  content: "\f02d";
  font-size: 25px;
  -webkit-text-stroke: 1px white;
  color: transparent;
  animation: f 0.9s linear infinite;
}
.loader .box:nth-child(6)::before {
  content: "\43";
  font-size: 18px;
  animation: g 1.2s linear infinite;
}

.loader.amit::before,
.loader.amit::after {
  transform: scale(1);
}

@keyframes a {
  0% {
    transform: translate(0px, 0) rotate(30deg);
    opacity: 0;
  }
  100% {
    transform: translate(0px, 150px) rotate(-50deg);
    opacity: 1;
  }
}
@keyframes b {
  0% {
    transform: translate(20px, 0) rotate(-40deg);
    opacity: 0;
  }
  100% {
    transform: translate(10px, 150px) rotate(80deg);
    opacity: 1;
  }
}
@keyframes c {
  0% {
    transform: translate(40px, 0) rotate(10deg);
    opacity: 0;
  }
  100% {
    transform: translate(30px, 150px) rotate(70deg);
    opacity: 1;
  }
}

@keyframes d {
  0% {
    transform: translate(70px, 0) rotate(10deg);
    opacity: 0;
  }
  100% {
    transform: translate(60px, 150px) rotate(70deg);
    opacity: 1;
  }
}

@keyframes e {
  0% {
    transform: translate(100px, 0) rotate(30deg);
    opacity: 0;
  }
  100% {
    transform: translate(100px, 150px) rotate(-50deg);
    opacity: 1;
  }
}
@keyframes f {
  0% {
    transform: translate(120px, 0) rotate(-40deg);
    opacity: 0;
  }
  100% {
    transform: translate(110px, 150px) rotate(80deg);
    opacity: 1;
  }
}
@keyframes g {
  0% {
    transform: translate(140px, 0) rotate(10deg);
    opacity: 0;
  }
  100% {
    transform: translate(130px, 150px) rotate(70deg);
    opacity: 1;
  }
}

@-webkit-keyframes spaceboots {
  0% {
    -webkit-transform: translate(2px, 1px) rotate(0deg);
  }
  10% {
    -webkit-transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    -webkit-transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    -webkit-transform: translate(0px, 2px) rotate(0deg);
  }
  40% {
    -webkit-transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    -webkit-transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    -webkit-transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    -webkit-transform: translate(2px, 1px) rotate(-1deg);
  }
  80% {
    -webkit-transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    -webkit-transform: translate(2px, 2px) rotate(0deg);
  }
  100% {
    -webkit-transform: translate(1px, -2px) rotate(-1deg);
  }
}
</style>
